import { EntryPointFrontend } from '@pbx/models/worksheet-actions/frontend/entry-point';
import { EntryPointBackend } from '@pbx/models/worksheet-actions/backend/entry-point';
import { CallFrontend } from '@pbx/models/worksheet-actions/frontend/call';
import { CallBackend } from '@pbx/models/worksheet-actions/backend/call';
import { QueueFrontend } from '@pbx/models/worksheet-actions/frontend/queue';
import { QueueBackend } from '@pbx/models/worksheet-actions/backend/queue';
import { MenuFrontend } from '@pbx/models/worksheet-actions/frontend/menu';
import { MenuBackend } from '@pbx/models/worksheet-actions/backend/menu';
import { PlaybackFrontend } from '@pbx/models/worksheet-actions/frontend/playback';
import { PlaybackBackend } from '@pbx/models/worksheet-actions/backend/playback';
import { PostbackFrontend } from '@pbx/models/worksheet-actions/frontend/postback';
import { PostbackBackend } from '@pbx/models/worksheet-actions/backend/postback';
import { TimeFrontend } from '@pbx/models/worksheet-actions/frontend/time';
import { TimeBackend } from '@pbx/models/worksheet-actions/backend/time';
import { ListFrontend } from '@pbx/models/worksheet-actions/frontend/list';
import { ListBackend } from '@pbx/models/worksheet-actions/backend/list';

export const LIST_ACTION_TYPES = [
  'entry',
  'call',
  'queue',
  'menu',
  'playback',
  'postback',
  'time',
  'list'
];

export class WorksheetActionModelSelector {
  static getFrontendModel(item) {
    const { type } = item;
    return WorksheetActionModelSelector.getFrontendModelByType(type, item);
  }

  static getFrontendModelByType(type, item) {
    if (type === 'entry') {
      return new EntryPointFrontend(item);
    } else if (type === 'call') {
      return new CallFrontend(item);
    } else if (type === 'queue') {
      return new QueueFrontend(item);
    } else if (type === 'menu') {
      return new MenuFrontend(item);
    } else if (type === 'playback') {
      return new PlaybackFrontend(item);
    } else if (type === 'postback') {
      return new PostbackFrontend(item);
    } else if (type === 'time') {
      return new TimeFrontend(item);
    } else if (type === 'list') {
      return new ListFrontend(item);
    }
  }

  static getBackendModel(item) {
    const { type } = item;
    return WorksheetActionModelSelector.getBackendModelByType(type, item);
  }

  static getBackendModelByType(type, item) {
    if (type === 'entry') {
      return new EntryPointBackend(item);
    } else if (type === 'call') {
      return new CallBackend(item);
    } else if (type === 'queue') {
      return new QueueBackend(item);
    } else if (type === 'menu') {
      return new MenuBackend(item);
    } else if (type === 'playback') {
      return new PlaybackBackend(item);
    } else if (type === 'postback') {
      return new PostbackBackend(item);
    } else if (type === 'time') {
      return new TimeBackend(item);
    } else if (type === 'list') {
      return new ListBackend(item);
    }
  }
}
